module.exports = __webpack_public_path__ + "static/img/icon3.a553ed22.png";